export function esNombreInvalido(value) {
 const name=String(value??'').trim();
 const letters=part=>/\p{L}/u.test(part);
 return !letters(name)||(name.includes(',')&&name.split(',').some(part=>!letters(part)));
}
function dayNumber(value) {
 const text=String(value??'').trim();
 let match=text.match(/^(\d{4})-(\d{2})-(\d{2})(?:T|\s|$)/);
 let y,m,d;
 if(match){[,y,m,d]=match;}else{
  match=text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s|$)/);
  if(!match)return null;[,d,m,y]=match;
 }
 const date=new Date(Date.UTC(+y,+m-1,+d));
 return date.getUTCFullYear()===+y&&date.getUTCMonth()===+m-1&&date.getUTCDate()===+d?date.getTime()/86400000:null;
}
export function requiereCorreccionFecha(row,days,now=new Date()) {
 const estado=String(row.Estado??'').trim().toUpperCase();
 const message=String(row.LOG_MENSAJE??'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase();
 const fueraDeFecha=/FUERA DE (FECHA|PLAZO)/.test(message);
 if(estado==='RECHAZADO')return fueraDeFecha;
 if(estado!=='PENDIENTE')return false;
 if(fueraDeFecha)return true;
 const type=String(row.TipoCPE??'').toUpperCase();
 const limit=/FACTURA|^01$/.test(type)?days?.factura:/BOLETA|^03$/.test(type)?days?.boleta:/NOTA|^0[78]$|^N[CD]$/.test(type)?days?.nota:null;
 const issued=dayNumber(row.Fecha);
 const today=dayNumber(new Date(now.getTime()-5*3600000).toISOString());
 return issued!==null&&today!==null&&Number.isFinite(limit)&&(issued>today||today-issued>limit);
}
